// extracted by mini-css-extract-plugin
export default {"joinCotainer":"joinByLink_joinCotainer__oChSd","offcameraContainer":"joinByLink_offcameraContainer__nNLP4","otherOptionMicrophone":"joinByLink_otherOptionMicrophone__rJNIb"};